window.addEventListener("load", function () {
    if ($('body').data('device-type') === 'desktop') {
        var $body = $('body');
        var initialDeviceType = $body.attr('data-device-type'); // Lấy giá trị hiện tại, không bị cache
        console.log('Device ban đầu:', initialDeviceType);
    
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-device-type') {
                    var currentDeviceType = $body.attr('data-device-type'); // Dùng attr thay vì data
    
                    if (currentDeviceType !== initialDeviceType) {
                        $('.layer-rotate').addClass('active');
                    } else {
                        $('.layer-rotate').removeClass('active');
                    }
                }
            });
        });
    
        observer.observe($body[0], { attributes: true });
    }
   
});

// document.addEventListener('touchmove', (event) => {
//     if (event.touches[0].clientY > 0) {

//         event.preventDefault();
//     }
// });

window.addEventListener("load", function () {

    $('.btn-scroll').on('click', function () {
        window.parent.postMessage({
            type: 'iframeBtnScroll',
        }, '*');
    });

    $('#vxphl-ld-25-a-navigation .btn-dangkytruoc').on('click', function () {
        $('.fakeClick-mb').eq(0).trigger('click');

        const iframe = document.querySelector('#promotion-iframe'); // hoặc getElementById nếu mày đặt ID

        // Gửi message vào iframe
        iframe.contentWindow.postMessage({
            type: 'iframeBtnPre',

        }, '*'); // '*' có thể đổi 
    });

});
window.addEventListener('wheel', function (e) {
    window.parent.postMessage({
        type: 'iframeWheel',
        deltaY: e.deltaY
    }, '*');
});

let touchStartY = 0;
let touchEndY = 0;
$(document).on('touchstart', function (e) {
    touchStartY = e.originalEvent.touches[0].clientY;
});

$(document).on('touchend', function (e) {
    touchEndY = e.originalEvent.changedTouches[0].clientY;
    const deltaY = touchEndY - touchStartY;
    if (window.self !== window.top) {

        window.parent.postMessage({
            type: 'iframeTouch',
            deltaY: deltaY
        }, '*');
    }
});

window.addEventListener('message', function (e) {
 

    if (e.data && e.data.type === 'iframeBtnPre') {
        console.log('Good');


    }

  
    if (e.data && e.data.type === 'iframeWheel') {
        const deltaY = e.data.deltaY;
        if (deltaY > 0) {
            $('.fakeClick').eq($('.frameActive').index() + 1).trigger('click');
        }
    }
    if (e.data && e.data.type === 'iframeBtnScroll') {
        $('.fakeClick').eq($('.frameActive').index() + 1).trigger('click');
    }
    if (e.data && e.data.type === 'iframeWater') {
        const deltaY = e.data.deltaY;
        if (deltaY < 0) {

            $('.fakeClick-mb').eq($('.frameActive').index() + 1).trigger('click');

        }
    }



    if (e.data && e.data.type === 'iframeTouch') {
        const deltaY = e.data.deltaY;
        if (deltaY < 0) {



            $('.fakeClick-mb').eq($('.frameActive').index() + 1).trigger('click');

        }
    }
});